export { default as providedServices } from "./provided-services.json";
export { default as headerMenu } from "./header-menu.json";
export { default as contactInfo } from "./contact-info.json";


import en from "./locale/en.json";
import id from "./locale/id.json";
const locale = { en, id };
export { locale };
